var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'message',
    {
      error: _vm.type === _vm.MessageType.Error,
      info: _vm.type === _vm.MessageType.Info,
      warning: _vm.type === _vm.MessageType.Warning,
    },
    _vm.color ]},[_c('BaseIcon',{class:[
      'icon',
      {
        error: _vm.type === _vm.MessageType.Error,
        info: _vm.type === _vm.MessageType.Info,
        warning: _vm.type === _vm.MessageType.Warning,
      },
      _vm.color ],attrs:{"icon":"info-circle"}}),_c('div',{class:['message-info', _vm.color]},[_c('BaseH4',[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }